import { useState } from 'react';
import { Flex, Row, Typography } from 'antd';
import { User } from '@Types/index';
import { Balance } from '@Types/api/form/leaveRequest/Balance';
import { MobileDrawer } from '@Components/index';
import { ReactComponent as LogoCompanyIcon } from '@Icons/additional/logo-company-default.svg';
import { ReactComponent as ChevroneIcon } from '@Icons/additional/chevrone-down.svg';
import { MAvatar } from '@Components/Base';
import { useAppSelector } from '@Hooks/index';
import { currentMaterialHeaderRequest } from '@Features/MaterialRequest/requests/MaterialRequisition/store/selectors/materialRequestSelector';

import BasicInformationSection from './components/BasicInformationSection/BasicInformationSection';
import MaterialRequestInformation from './components/MaterialRequestInformation/MaterialRequestInformation';

import styles from './information-sidebar-mobile.module.css';

interface InformationSidebarMobileProps {
  userInfo: User;
  selectedUser?: User;
  showMRsection?: boolean;
  showSelectEmployee?: boolean;
  showLeaveBalance?: boolean;
  showExtraUserFields?: boolean;
  balance?: Balance;
  requestHeaderStep?: boolean;
  handleSearchEmpByNumber?: (empNumber?: string) => void;
  handleApplySelectedUser?: () => void;
}

const MobileLayout: React.FC<InformationSidebarMobileProps> = ({
  requestHeaderStep,
  showMRsection,
  userInfo,
  selectedUser,
  showLeaveBalance,
  showSelectEmployee,
  showExtraUserFields,
  handleSearchEmpByNumber,
  handleApplySelectedUser,
  balance,
}) => {
  const [showUserInfo, setIsShowUserInfo] = useState(false);
  const { companyName } = useAppSelector(currentMaterialHeaderRequest);

  return (
    <Row gutter={[20, 20]} className={styles.basicInformationContainer}>
      <div
        className={styles.informationOpenSection}
        onClick={() => setIsShowUserInfo(!requestHeaderStep)}
      >
        {showMRsection && requestHeaderStep ? (
          <MaterialRequestInformation requestHeaderStep={requestHeaderStep} />
        ) : (
          <Flex className={styles.informationUserSection}>
            <div>
              {showMRsection && !requestHeaderStep ? (
                <LogoCompanyIcon style={{ width: '24px', height: '24px' }} />
              ) : (
                <MAvatar size={24} />
              )}
            </div>
            <Flex className={styles.informationUserDesc} justify="center">
              <Typography.Text
                className={styles.informationUserName}
                strong
                ellipsis
              >
                {showMRsection && !requestHeaderStep ? (
                  <span className={styles.informationMRname}>
                    {companyName}
                  </span>
                ) : (
                  userInfo.empName
                )}
              </Typography.Text>
            </Flex>
            <div className={styles.informationShowMoreButton}>
              <ChevroneIcon />
            </div>
          </Flex>
        )}
      </div>
      <MobileDrawer
        open={showUserInfo}
        onClose={() => setIsShowUserInfo(false)}
      >
        {showMRsection ? (
          <MaterialRequestInformation requestHeaderStep={requestHeaderStep} />
        ) : (
          <BasicInformationSection
            userInfo={userInfo}
            selectedUser={selectedUser}
            showLeaveBalance={showLeaveBalance}
            balance={balance}
            showSelectEmployee={showSelectEmployee}
            handleSearchEmpByNumber={handleSearchEmpByNumber}
            handleApplySelectedUser={handleApplySelectedUser}
            showExtraFields={showExtraUserFields}
          />
        )}
      </MobileDrawer>
    </Row>
  );
};

export default MobileLayout;
